import { render, staticRenderFns } from "./createCompanyAccount.vue?vue&type=template&id=05538dc4&scoped=true&"
import script from "./createCompanyAccount.vue?vue&type=script&lang=js&"
export * from "./createCompanyAccount.vue?vue&type=script&lang=js&"
import style0 from "./createCompanyAccount.vue?vue&type=style&index=0&id=05538dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05538dc4",
  null
  
)

export default component.exports